module.exports = ".raul-header-icon-wrap {\n  float: right; }\n\n.raul-header-help:before {\n  vertical-align: top; }\n\n.raul-header-help {\n  float: left;\n  font-size: 24px;\n  cursor: pointer;\n  color: #fff;\n  margin: 16px 10px; }\n\n#raul-header-help-block .dropdown-item:hover {\n  background-color: #AFB3B6;\n  cursor: pointer; }\n\n#raul-header-help-block .dropdown-toggle::after {\n  display: none; }\n\n#raul-header-help-block .dropdown-item {\n  color: black;\n  font-size: 14px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/layout/help-icon.component.scss
// module id = ./src/app/shared/components/layout/help-icon.component.scss
// module chunks = main